import {
	HomeOutlined,
	UserOutlined,
	UsergroupAddOutlined,
	WindowsOutlined,
	DesktopOutlined,
	BuildOutlined,
	StarOutlined,
	AuditOutlined,
	LaptopOutlined,
} from "@ant-design/icons";
import { APP_PREFIX_PATH } from "configs/AppConfig";
import {
	PermissaoGrupoUsuarioEnum,
	PermissaoUsuarioEnum,
	PermissaoSistemaOperacionalEnum,
	PermissaoModeloMaquinaEnum,
	PermissaoCategoriaDriverEnum,
	PermissaoDriverEnum,
	PermissaoMaquinaEnum,
	PermissaoVersaoSistemaEnum,
} from "enum/permissao-enum";

const dashBoardNavTree = [
	{
		key: "dashboard",
		path: `${APP_PREFIX_PATH}/dashboard`,
		title: "dashboard",
		icon: HomeOutlined,
		breadcrumb: false,
		submenu: [],
	},
	{
		key: "lista-usuarios",
		path: `${APP_PREFIX_PATH}/lista-usuarios`,
		title: "lista-usuarios",
		icon: UserOutlined,
		breadcrumb: false,
		submenu: [],
		permissao: PermissaoUsuarioEnum.VISUALIZAR,
	},
	{
		key: "lista-grupos-usuario",
		path: `${APP_PREFIX_PATH}/lista-grupos-usuario`,
		title: "lista-grupos-usuario",
		icon: UsergroupAddOutlined,
		breadcrumb: false,
		submenu: [],
		permissao: PermissaoGrupoUsuarioEnum.VISUALIZAR,
	},
	{
		key: "lista-sistema-operacional",
		path: `${APP_PREFIX_PATH}/lista-sistema-operacional`,
		title: "lista-sistema-operacional",
		icon: WindowsOutlined,
		breadcrumb: false,
		submenu: [],
		permissao: PermissaoSistemaOperacionalEnum.VISUALIZAR,
	},
	{
		key: "lista-modelo-maquina",
		path: `${APP_PREFIX_PATH}/lista-modelo-maquina`,
		title: "lista-modelo-maquina",
		icon: DesktopOutlined,
		breadcrumb: false,
		submenu: [],
		permissao: PermissaoModeloMaquinaEnum.VISUALIZAR,
	},
	{
		key: "lista-categoria-driver",
		path: `${APP_PREFIX_PATH}/lista-categoria-driver`,
		title: "lista-categoria-driver",
		icon: BuildOutlined,
		breadcrumb: false,
		submenu: [],
		permissao: PermissaoCategoriaDriverEnum.VISUALIZAR,
	},
	{
		key: "lista-driver",
		path: `${APP_PREFIX_PATH}/lista-driver`,
		title: "lista-driver",
		icon: StarOutlined,
		breadcrumb: false,
		submenu: [],
		permissao: PermissaoDriverEnum.VISUALIZAR,
	},
	{
		key: "lista-maquina",
		path: `${APP_PREFIX_PATH}/lista-maquina`,
		title: "lista-maquina",
		icon: AuditOutlined,
		breadcrumb: false,
		submenu: [],
		permissao: PermissaoMaquinaEnum.VISUALIZAR,
	},
	{
		key: "lista-versao-sistema",
		path: `${APP_PREFIX_PATH}/lista-versao-sistema`,
		title: "lista-versao-sistema",
		icon: LaptopOutlined,
		breadcrumb: false,
		submenu: [],
		permissao: PermissaoVersaoSistemaEnum.VISUALIZAR_TELA,
	},
];

const navigationConfig = [...dashBoardNavTree];

export default navigationConfig;
